import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.post("/statistics/guide/index",{...params
    } )
}

export default {
    GET_LIST,
};
